import { render, staticRenderFns } from "./SideList.vue?vue&type=template&id=4a20d00e&scoped=true&"
import script from "./SideList.vue?vue&type=script&lang=js&"
export * from "./SideList.vue?vue&type=script&lang=js&"
import style0 from "./SideList.vue?vue&type=style&index=0&id=4a20d00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20d00e",
  null
  
)

/* custom blocks */
import block0 from "./SideList.vue?vue&type=custom&index=0&blockType=el-select&v-model=select&style=width%3A%20100px%3B&slot=prepend&placeholder=%E7%AD%89%E7%BA%A7"
if (typeof block0 === 'function') block0(component)
import block1 from "./SideList.vue?vue&type=custom&index=1&blockType=span&slot=footer&class=dialog-footer"
if (typeof block1 === 'function') block1(component)
import block2 from "./SideList.vue?vue&type=custom&index=2&blockType=taskListDialog&ref=taskListDialog"
if (typeof block2 === 'function') block2(component)
import block3 from "./SideList.vue?vue&type=custom&index=3&blockType=el-dialog&%3Atitle=summaryTaskTitle&%3Avisible.sync=summaryTaskDialogVisible&width=800px&center=true"
if (typeof block3 === 'function') block3(component)
import block4 from "./SideList.vue?vue&type=custom&index=4&blockType=el-dialog&title=%E6%89%80%E6%9C%89%E6%80%BB%E7%BB%93&%3Avisible.sync=allSummaryVisible&top=5px&width=450px&center=true&append-to-body=true"
if (typeof block4 === 'function') block4(component)
import block5 from "./SideList.vue?vue&type=custom&index=5&blockType=side-tags-record-dialog&ref=SideTagsRecordDialog"
if (typeof block5 === 'function') block5(component)
import block6 from "./SideList.vue?vue&type=custom&index=6&blockType=SelectTaskChatSession&ref=selectTaskChatSession"
if (typeof block6 === 'function') block6(component)

export default component.exports